<!--
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2024-12-26 13:21:43
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-02-10 19:41:38
 * @FilePath: \vooglam-pc-ssr\directive\LoadingCom.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <transition name="fade">
    <div v-show="loadingFlag" class="loader" :style="{ 'z-index': zIndexNumber }">
      <div class="loader_inner" :style="{ top }">
        <img src="@/assets/images/loading.png" class="app-loader-img" alt="" />
        <NuxtImgWrap
          src="https://common.xmslol.com/vooglam/loading/loading_circle.png"
          class="app-loader-img loader_circle"
          alt=""
        />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

export interface LoadingComProps {
  top?: string;
  zIndex?: string | number;
}

export interface LoadingComInstance {
  show: () => void;
  hide: () => void;
  $el: HTMLElement;
}

const props = withDefaults(defineProps<LoadingComProps>(), {
  top: '25%',
  zIndex: 1997000,
});

// 转换 zIndex 为数字用于比较
const zIndexNumber = computed(() => {
  return typeof props.zIndex === 'string' ? parseInt(props.zIndex, 10) : props.zIndex;
});

const loadingFlag = ref(false);

// 暴露方法而不是直接暴露 ref
const show = () => {
  loadingFlag.value = true;
};

const hide = () => {
  loadingFlag.value = false;
};

defineExpose({
  show,
  hide,
});
</script>

<style lang="scss">
/* 全局loading与自定义指令的loading样式 */
.loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgb(255 255 255 / 50%);
}
.loader .loader_inner {
  position: absolute;
  z-index: 10;
  left: 50%;
  width: 60px;
  transform: translate(-50%, -50%);
}
.loader .app-loader-img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
}
.loader .app-loader-img.loader_circle {
  animation: loadingAnimation 1.2s cubic-bezier(0.4, 0.12, 0.67, 0.93) infinite;
}

@keyframes loadingAnimation {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 自定义指令 vgLoading loading 父级绑定的class */
.nextmar-loading-parent--relative {
  position: relative;
}
.nextmar-loading-parent--min-height {
  min-height: 800px;
}
.nextmar-loading-parent--account-min-height {
  min-height: 600px;
}
</style>
